<form [formGroup]="roleService.entity">
  <div class="grid">
    <div class="col-12">
      <div class="field">
        <label for="name">
          <span class="p-error">*</span>Nombre del role:
        </label>
        <input type="text" pInputText id="name" formControlName="name" placeholder="Nombre del role" />
        <ng-container *ngIf="e.get('name')?.invalid && (e.get('name')?.dirty || e.get('name')?.touched)">
          <small class="p-error" *ngIf="e.get('name')?.errors?.['required']">El nombre es obligatorio.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field">
        <label for="permission">
          <span class="p-error">*</span>Permisos:
        </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="permission" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="roleService.permissions" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona los permisos">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="e.value.roleId">
                <div>{{roleService.getPermissionName(e.value.permission)}}</div>
              </div>
            </ng-template>
            <ng-template let-permission pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ permission.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container *ngIf="e.get('permission')?.invalid && (e.get('permission')?.dirty || e.get('permission')?.touched)">
            <small class="p-error" *ngIf="e.get('permission')?.errors?.['required']">Los permisos son obligatorios.</small>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="field">
        <label for="description">
          <span class="p-error">*</span>Descripción del role:
        </label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="description" id="description"></textarea>
        <ng-container *ngIf="e.get('description')?.invalid && (e.get('description')?.dirty || e.get('description')?.touched)">
          <small class="p-error" *ngIf="e.get('description')?.errors?.['required']">La descripción es obligatorio.</small>
        </ng-container>
      </div>
    </div>
  </div>
</form>
